import { buildErrorThrower } from '@clerk/shared/error';

// src/utils/index.ts
var isClient = () => typeof window !== "undefined";
var isServer = () => !isClient();
var errorThrower = buildErrorThrower({
  packageName: "@clerk/tanstack-react-start"
});

export { errorThrower, isClient, isServer };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map